import { ReactNode } from "react"
import { usePage } from "@inertiajs/react"
import DefaultLayout from "@/layouts/DefaultLayout"
import Container from "@/components/Container"
import SEO from "@/components/SEO"
import AdminTweets from "@/components/AdminTweets"
import { PromotionManageProps } from "@/types/types"

const PromotionManagePage = () => {
  const { promotion } = usePage<PromotionManageProps>().props

  return (
    <>
      <SEO />

      <Container
        tag="section"
        maxWidthClassName="max-w-xl"
        className="pt-16 sm:pt-20"
      >
        <h1 className="mb-12 text-xl font-bold sm:text-2xl">
          {promotion.title}
        </h1>

        <AdminTweets tweets={promotion.tweets} promotionSlug={promotion.slug} />
      </Container>
    </>
  )
}

export default PromotionManagePage

PromotionManagePage.layout = (page: ReactNode) => (
  <DefaultLayout>{page}</DefaultLayout>
)
